import {HandHistoryList, HistoricHand} from '../../../../communication/PlayerApiProtocol.generated'

export interface SessionGroup {
    hands: HistoricHand[];
    id: string;
    firstHandTime: number;
    tableName: string;
    smallBlind: number;
    bigBlind: number;
    currencyCode: string;
    type: string;
}

export class HandHistoryUtils {
	static reverseOrder(hands: HistoricHand[]): HistoricHand[] {
		return hands.slice(0).reverse()
	}

	static toHandSessions(list: HandHistoryList): SessionGroup[] {
		const groups: SessionGroup[] = []
		let prev: SessionGroup = null
		list.hands.forEach(hand => {
			let group = prev
			if (!prev || group.id != hand.table.tableIntegrationId) {
				group = {
					hands: [],
					id: hand.table.tableIntegrationId,
					tableName: hand.table.tableName,
					smallBlind: hand.settings.smallBlind,
					bigBlind: hand.settings.bigBlind,
					currencyCode: hand.settings.currencyCode,
					type: hand.settings.betStrategyType,
					firstHandTime: hand.startTime,
				}
				groups.push(group)
			}

			group.hands.push(hand)
			prev = group
		})

		return groups
	}

	static isFirstHandInSession(activeHandIndex: number): boolean {
		return activeHandIndex === 0
	}

	static isFirstSessionLoaded(sessionIndex: number): boolean {
		return sessionIndex === 0
	}

	static isFirstPage(previousPages: number[]): boolean {
		return !previousPages.length
	}

	static isLastHandInCurrentSession(sessionIndex: number, handIndex: number, sessions: SessionGroup[]): boolean {
		return !sessions.length || handIndex === sessions[sessionIndex].hands.length - 1
	}

	static isLastLoadedSession(sessionIndex: number, sessions: SessionGroup[]): boolean {
		return sessionIndex === sessions.length - 1
	}
}